import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'
import transportModes from '@/store/transportModes'
import createPersistedState from 'vuex-persistedstate';
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({

    state: {
        origin: '',
        destinationEnable: 'Western Avenue, Perth PH1 1LN, United Kingdom',
        destinationRaigmore: 'Raigmore Hospital, Inverness IV2 3UJ',
        destination: '',
        arriveDate: '',
        arriveTime: '',
        arriveTimeHour: '09',
        arriveTimeMins: '00',
        arriveDateAndTime: '',
        railcardType: '',
        hasAccessToCar: false,
        hasConcessionaryPass: false,
        returnDate: null,
        via: null,
        journeyFilter: 'all',
        journeySorting: 'duration',
        journeyTypeFilter: false,
        journeyResults: [],
        journeyType: 'single',
        currentLocation: null,
        results: [],
        isLoading: false,
        currentJourney: null,
        searchQuery: null,
        activeCampaign: null,
        activeCampaignImpression: null,
        campaignImpressions: [],
        errors: {
            arrive_time: false,
            origin: false,
            destination: false,
        },
        mapping: {
            transportModes,
        },
        planner: {
            destinations: [],
            currentDestination: null,
        },
    },
    mutations: {
        updateOrigin(state, origin) {
            state.origin = origin
        },
        updateDestination(state, destination) {
            state.destination = destination
        },
        updateArriveDate(state, arriveDate) {
            state.arriveDate = arriveDate
        },
        updateArriveDateAndTime(state, arriveDateAndTime) {
            state.arriveDateAndTime = arriveDateAndTime
        },
        updateArriveTimeHour(state, arriveTimeHour) {
            state.arriveTimeHour = arriveTimeHour
        },
        updateArriveTimeMinutes(state, arriveTimeMins) {
            state.arriveTimeMins = arriveTimeMins
        },
        updateArriveTime(state, arriveTime) {
            state.arriveTime = arriveTime
        },
        updateRailcardType(state, railcardType) {
            state.railcardType = railcardType
        },
        updateHasAccessToCar(state, hasAccessToCar) {
            state.hasAccessToCar = hasAccessToCar
        },
        updateHasConcessionaryPass(state, hasConcessionaryPass) {
            state.hasConcessionaryPass = hasConcessionaryPass
        },
        updateJourneySorting(state, journeySorting) {
            state.journeySorting = journeySorting
        },
        updateJourneyFilter(state, journeyFilter) {
            state.journeyFilter = journeyFilter
        },
        updateJourneyResults(state, journeyResults) {
            state.journeyResults = journeyResults
        },
        updateJourneyTypeFilter(state, journeyTypeFilter) {
            state.journeyTypeFilter = journeyTypeFilter
        },
        updateReturnDate(state, returnDate) {
            state.returnDate = returnDate
        },
        updateJourneyType(state, journeyType) {
            state.journeyType = journeyType
        },
        updateVia(state, via) {
            state.via = via
        },
        updateCurrentLocation(state, latLng) {
            state.currentLocation = latLng
        },
        setResults(state, items) {
            Vue.set(state, 'results', items)
        },
        addToResults(state, item) {
            const placeholderID = state.results.findIndex((i) => i.showPlaceholder)
            if (placeholderID >= 0) {
                Vue.set(state.results, placeholderID, item)
            } else {
                state.results.push(item)
            }
        },
        clearResults(state) {
            Vue.set(state, 'results', [])
        },
        setLoading(state, loading) {
            state.isLoading = loading
        },
        setCurrentJourney(state, journey) {
            Vue.set(state, 'currentJourney', journey)
        },
        setSearchQuery(state, searchQuery) {
            const data = searchQuery
            /* we don't need journeys - they are stored under results */
            delete data.journeys
            Vue.set(state, 'searchQuery', data)
        },
        setError(state, { field, error }) {
            state.errors[field] = error
        },
        setSearchQueryResults(state, results) {
            state.searchQuery.results_retrieved = results
        },
        setPlannerDestinations(state, results) {
            Vue.set(state.planner, 'destinations', results)
        },
        setCurrentDestination(state, result) {
            Vue.set(state.planner, 'currentDestination', result)
        },
        activeCampaign(state, response) {
            state.activeCampaign = response
        },
        addCampaignImpression(state, impression) {
            state.campaignImpressions.push(impression)
            state.activeCampaignImpression = impression
        },
    },
    actions: {
        searchQuery({ commit }, { params, router }) {
            commit('setLoading', true)
            api.planner.search(params)
                .then((response) => {
                    if (response.data.status) {
                        commit('setSearchQuery', response.data.data)
                        router.push({ name: 'Results', params: { hash: response.data.data.hash } })
                    }
                })
                .catch((error) => {
                    if (error.response.data.errors.arrive_time) {
                        commit('setError', {
                            field: 'arrive_time',
                            error: error.response.data.errors.arrive_time[0],
                        })
                    }
                    if (error.response.data.errors.origin) {
                        commit('setError', {
                            field: 'origin',
                            error: error.response.data.errors.origin[0],
                        })
                    }
                })
        },
        updateReturnTime({ commit }, { hash, params, router }) {
            commit('setLoading', true)
            api.planner.updateReturnTime(hash, params)
                .then((response) => {
                    if (response.data.status) {
                        commit('setSearchQuery', response.data.data)
                        router.push({ name: 'Results', params: { hash: response.data.data.hash } })
                    }
                })
                .catch((error) => {
                    if (error.response.data.errors.arrive_time) {
                        commit('setError', {
                            field: 'arrive_time',
                            error: error.response.data.errors.arrive_time[0],
                        })
                    }
                    if (error.response.data.errors.origin) {
                        commit('setError', {
                            field: 'origin',
                            error: error.response.data.errors.origin[0],
                        })
                    }
                }).then(() => {
                    commit('setLoading', false)
                })
        },
        retrieveResults({ commit }, hash) {
            commit('setLoading', true)
            api.planner.getJourneys(hash)
                .then((response) => {
                    commit('clearResults')
                    if (response.data.data.journeys.length) {
                        response.data.data.journeys.forEach((item) => {
                            commit('addToResults', { showPlaceholder: false, journey: item })
                        })
                    }
                    commit('setSearchQuery', response.data.data)
                })
                .catch((error) => {
                    console.log(error.response)
                })
                .then(() => {
                    commit('setLoading', false)
                })
        },
        retrieveSingleJourney({ commit, state }, { hash, journeyID, successCallback = false }) {
            commit('setLoading', true)
            api.planner.getSingleJourney(hash, journeyID)
                .then((response) => {
                    const item = response.data.data
                    commit('addToResults', { showPlaceholder: false, journey: item })
                    if (!state.currentJourney) {
                        commit('setCurrentJourney', item)
                    }
                    if (successCallback) {
                        successCallback()
                    }
                })
                .catch((error) => {
                    console.log(error.response)
                })
                .then(() => {
                    commit('setLoading', false)
                })
        },
        retrievePlannerDestinations({ commit }, search = '') {
            api.planner.getPlannerDestinations(search)
                .then((response) => {
                    commit('setPlannerDestinations', response.data.data)
                })
                .catch((error) => {
                    console.log(error.response)
                })
        },
        getActiveCampaign({ commit }, { params }) {
            api.campaigns.getActiveCampaign(params)
                .then((response) => {
                    if (response.data.data.length === 1) {
                        commit('activeCampaign', response.data.data[0])
                    }
                });
        },
        recordCampaignImpression({ commit }, { params }) {
            api.campaigns.recordCampaignImpression(params)
                .then((response) => {
                    if (response.data.data) {
                        commit('addCampaignImpression', response.data.data)
                    }
                });
        },
        resetActiveCampaignAndImpression({ commit }) {
            commit('resetActiveCampaignAndImpression')
        },
    },
    getters: {
        getJourneyById: (state) => (id) => state.results.find((item) => item.journey.id === id),
        allResultsRetrieved: (state) => (state.searchQuery ? state.searchQuery.results_retrieved <= state.results.length : false),
        getMapIconByTransportMode: (state) => (transportMode) => `/img/map/${[process.env.VUE_APP_BRAND]}/${state.mapping.transportModes[transportMode]}.png`,
        getSVGIconNameByTransportMode: (state) => (transportMode) => `${[process.env.VUE_APP_BRAND]}/${state.mapping.transportModes[transportMode] ? state.mapping.transportModes[transportMode] : transportMode}`,
        getIconNamesByStage: (state, getters) => (stage) => _.uniqBy(state.currentJourney[stage].stages.map((item) => getters.getSVGIconNameByTransportMode(item))),
        getIconsAndNamesByStage: (state, getters) => (journey, stage) => _.uniqBy(journey[stage].stages.map((item) => ({ icon: getters.getSVGIconNameByTransportMode(item), name: item })), 'name'),
        getSVGCircledIconNameByTransportMode: (state, getters) => (transportMode) => `${getters.getSVGIconNameByTransportMode(transportMode)}-c`,
        campaignImpressionIds: (state) => state.campaignImpressions.map((impression) => impression.id),
        getCo2: (state) => {
            const carbon = []

            if (state.results.length) {
                for (let i = 0; i < state.results.length; i += 1) {
                    const item = state.results[i]
                    carbon.push(item.journey.carbon_emission)
                }
            }
            return _.sortBy(carbon)
        },
    },
    plugins: [
        createPersistedState({
            paths: ['campaignImpressions'],
        }),
    ],
})
